/* ============================================================
   PRINCE DADDY & THE HYENA — Hotwire Trip Switch
   Custom Theme JS
   ============================================================ */

(function () {
  'use strict';

  // ── Smooth scroll: nav links with [data-scroll-to] ──────────────

  function initNavScroll() {
    document.querySelectorAll('[data-scroll-to]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = this.dataset.scrollTo;
        var target = document.getElementById(targetId);
        if (!target) return; // let the href navigate normally
        e.preventDefault();
        scrollToSection(target);
      });
    });
  }

  function scrollToSection(el) {
    var navHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--pd-nav-height')
    ) || 60;
    var top = el.getBoundingClientRect().top + window.scrollY - navHeight - 8;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  // ── Hash-based scroll on page load (deep links back to homepage) ─

  function initHashScroll() {
    if (!window.location.hash) return;
    var targetId = window.location.hash.replace('#', '');
    var target = document.getElementById(targetId);
    if (!target) return;
    // Small delay to let the page render fully
    setTimeout(function () {
      scrollToSection(target);
    }, 120);
  }

  // ── Parallax ────────────────────────────────────────────────────

  function initParallax() {
    var clouds = document.querySelectorAll('.js-parallax');
    if (!clouds.length) return;

    var ticking = false;

    function update() {
      clouds.forEach(function (cloud) {
        var speed = parseFloat(cloud.dataset.parallaxSpeed) || 100.99;
        var section = cloud.closest('.pdaddy-section');
        if (!section) return;

        var rect = section.getBoundingClientRect();
        var sectionCenter = rect.top + rect.height / 2;
        // var viewportCenter = window.innerHeight / 2;
                var viewportCenter = 1000;
        var offset = (viewportCenter - sectionCenter) * speed;

        cloud.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Run once on load
    update();
  }

  // ── Tour: expand/collapse events ────────────────────────────────

  function initTourToggle() {
    var btn = document.querySelector('.js-tour-toggle');
    var wrap = document.querySelector('.pdaddy-tour__widget-wrap');
    if (!btn || !wrap) return;

    btn.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      btn.textContent = expanded ? 'Show Less' : 'View All Dates';
    });
  }

  // ── Cart count live update ───────────────────────────────────────
  // Dawn publishes a PubSub event when the cart changes; update our badge.

  function initCartCount() {
    var badge = document.querySelector('.pdaddy-nav__cart-count');
    if (!badge) return;

    // Dawn's pubsub publishes to 'cart:refresh' or similar; listen for fetch
    document.addEventListener('cart:refresh', function (e) {
      var count = e.detail && e.detail.cartData && e.detail.cartData.item_count;
      if (count !== undefined) {
        badge.textContent = count;
        badge.style.display = count > 0 ? '' : 'none';
      }
    });
  }

  // ── Bandsintown "Show All Dates" → custom page ───────────────────

  function initShowAllDates() {
    // Use capture phase (true) so our handler fires before the widget's own handler
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.bit-upcoming-events-show-all-button');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = '/pages/tour';
    }, true);
  }

  // ── Init ─────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    initNavScroll();
    initHashScroll();
    initParallax();
    initTourToggle();
    initCartCount();
    initShowAllDates();
  });
})();
